export default function SpecSummaryCard({

    title,

    value,

    subtitle,

    color = "#29b95f",

    icon

}) {

    return (

        <div className="summaryCard">

            <div className="summaryTop">

                <div>

                    <div className="summaryTitle">

                        {title}

                    </div>

                    <div className="summaryValue">

                        {value}

                    </div>

                    <div className="summarySubtitle">

                        {subtitle}

                    </div>

                </div>

                <div
                    className="summaryIcon"
                    style={{ color }}
                >
                    {icon}
                </div>

            </div>

        </div>

    );

}